import { DiagnosticsService } from "../services/diagnostics.service";
import { Injector, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs/Subscription";


export abstract class DiagnosedItem implements OnDestroy {

    private __me__: any;
    private __diag__: DiagnosticsService;

    private __subscriptions__: Subscription[] = [];

    constructor(private __injector__: Injector) {
        if (__injector__) {
            this.__me__ = this.constructor;
            this.__diag__ = __injector__.get(DiagnosticsService);
            this.__diag__.registerInstance(this.__me__);
        }
    }

    public registerSubscription(subscription: Subscription) {
        this.__subscriptions__.push(subscription);
    }

    private disposeSubscriptions() {
        if (!this.__subscriptions__) return;

        this.__subscriptions__
            .forEach(x => {
                x && x.unsubscribe && x.unsubscribe();
            });
    }

    destroy() {
    }

    ngOnDestroy() {
        if (this.__me__) {
            this.destroy();
            this.__diag__.disposeInstance(this.__me__);
            this.disposeSubscriptions();
        }
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/dataModels/diagnosed-item.ts